var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#6E7882",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6238 6.67061C15.8057 6.46285 16.1216 6.4419 16.3294 6.62381C16.5371 6.80572 16.5581 7.12161 16.3762 7.32937L11.5391 12.8537C10.8043 13.6929 9.58447 13.7197 8.82028 12.9055L3.63542 7.3812C3.44645 7.17984 3.45648 6.86342 3.65783 6.67444C3.85918 6.48547 4.1756 6.4955 4.36458 6.69685L9.54943 12.2212C9.90589 12.601 10.438 12.5932 10.7868 12.1949L15.6238 6.67061Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.97e227548d631854941a5675f1375b79.svg";
export { ForwardRef as ReactComponent };